<app-idle-timeout></app-idle-timeout>
<router-outlet></router-outlet>
<footer>Version: {{ version }}</footer>
